import { Col, Select, Typography } from "antd";
import { useSelector } from "react-redux";

const { Text } = Typography

export const FourthStep = ({
    applyToPlayers,
    setApplyToPlayers,
    applyToPlayerLabels,
    setApplyToPlayerLabels
}: IFourthStep) => {
    const {
        positions,
        playerGroups: groups,
        allPlayers,
    } = useSelector(({ team }) => team);

    return (
        <Col style={{ rowGap: '10px', display: 'flex', flexDirection: 'column' }}>
            <Text>Who would you like to apply these baselines to?</Text>

            <Select
                mode="multiple"
                labelInValue
                showSearch
                filterOption={(input, option: any) => {
                    if (option?.label) {
                        return option.label.toLowerCase().includes(input.toLowerCase());
                    }
                    return false;
                }}
                onChange={(data: any) => {
                    setApplyToPlayerLabels(data.map((e: any) => e.label))
                    setApplyToPlayers(data.map((e: any) => e.value))
                }}
                value={applyToPlayers.map((value, index) => ({
                    label: applyToPlayerLabels[index] || value,
                    value: value
                }))}
                placeholder="Players, Positions, Groups"
                options={[
                    {
                        label: 'Team',
                        options: [
                            { label: 'Full Team', value: 'full-team' }
                        ]
                    },
                    {
                        label: 'Players',
                        options: allPlayers.map((player: any) => {
                            return { label: `${player.first_name} ${player.last_name}`, value: `player-${player.player_id}` }
                        })
                    },
                    {
                        label: 'Positions',
                        options: positions.map((position: any) => {
                            return { label: position, value: `pos-${position}` }
                        })
                    },
                    {
                        label: 'Groups',
                        options: groups.map((group: any) => {
                            return { label: group.name, value: `group-${group.player_group_id}` }
                        })
                    }
                ]}
            >
            </Select>
        </Col >
    )
}

interface IFourthStep {
    applyToPlayers: string[];
    setApplyToPlayers: React.Dispatch<React.SetStateAction<string[]>>;
    applyToPlayerLabels: string[];
    setApplyToPlayerLabels: React.Dispatch<React.SetStateAction<string[]>>;
}

export default FourthStep